import { createFileRoute } from '@tanstack/react-router';
import Login from '@src/pages/Auth/Login';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/auth/login')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('auth.login', 'Login') }],
  }),
  component: Login,
});
